<template>
    <Dropdown
        v-if="typesOptions && typesOptions.length > 0"
        class="me-1 mb-1 types-filter"
        :color="isActive ? 'success' : 'secondary'"
        :title="isActive ? `Filter by types (${value.length})` : 'Filter by types'"
        small
    >
        <li v-for="type in typesOptions" :key="type.id">
            <div class="d-flex justify-content-between">
                <button
                    @click="setSelectedTypes(type)"
                    class="dropdown-item text-xs"
                    :class="value.includes(type.id) ? 'bg-primary text-white' : 'bg-white'"
                >
                    {{ getLabelAndCount(type) }}
                </button>
                <ButtonCollapse v-if="hasChildren(type)" :inline="inlineArrow" :target="getCollapseId(type.id)" />
            </div>
            <ul v-if="hasChildren(type)" :id="getCollapseId(type.id)" class="list-unstyled collapse text-xs">
                <li v-for="childType in type.children" :key="childType.id">
                    <button
                        @click="setSelectedTypes(childType)"
                        class="dropdown-item rounded-0 text-xxs ps-5"
                        :class="value.includes(childType.id) ? 'bg-primary text-white' : 'bg-light'"
                    >
                        {{ getLabelAndCount(childType) }}
                    </button>
                </li>
            </ul>
        </li>
    </Dropdown>
</template>

<script>
    import Types from '@/mixins/Types'
    import { Dropdown } from '@tech_hexeko/design-system'
    import ButtonCollapse from '@/components/ButtonCollapse'

    export default {
        components: {
            ButtonCollapse,
            Dropdown,
        },
        mixins: [Types],
        props: {
            inlineArrow: {
                type: Boolean,
                default: false,
            },
            value: {
                type: Array,
                required: true,
            },
        },
        emits: ['input'],
        computed: {
            isActive() {
                return this.value && this.value.length > 0
            },
        },
        methods: {
            getCollapseId(id) {
                return `type-${id}`
            },
            getLabelAndCount(typeObject) {
                let label = typeObject?.label
                if (this.hasChildren(typeObject)) {
                    const commonCount = typeObject?.children?.filter((child) => this.value.includes(child.id))?.length
                    if (commonCount > 0) label += ` (${commonCount})`
                }
                return label
            },
            hasChildren(typeObject) {
                return Boolean(typeObject?.children?.length > 0)
            },
            setSelectedTypes(typeObject) {
                let allIds = []
                // Automatically add/remove all children of parent type
                if (this.hasChildren(typeObject)) allIds = typeObject.children.map((child) => child.id)
                allIds.push(typeObject.id)
                // Add or remove IDs
                if (this.value?.includes(typeObject.id)) {
                    allIds = this.value?.filter((id) => !allIds.includes(id))
                } else {
                    allIds = [...new Set([...this.value, ...allIds])]
                }
                // Emit result
                this.$emit('input', allIds)
            },
        },
    }
</script>

<style scoped>
    .types-filter {
        margin-top: 0.4rem;
    }
</style>
